import React, { useEffect, useState } from "react";
import { ReactComponent as ThreeDot } from "../../../../../assets/MainPage/viewBlocks/ThreeDotIon.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/MainPage/viewBlocks/editIcon.svg";
import { ReactComponent as EditIconDark } from "../../../../../assets/MainPage/viewBlocks/editIcon-dark.svg";
import { MdAdd } from "react-icons/md";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { Link, useNavigate } from "react-router-dom";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  creatingLinkBlock,
  resetUser,
} from "../../../../../redux/slices/block/createBioLinkButtonSlice";
import {
  gettingLinkList,
  resetLinkList,
} from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import { toast } from "react-hot-toast";

// form
import LinkForm from "../forms/LinkForm";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";
import { creatingChangeBLock } from "../../../../../redux/slices/block/changeStatusBlockSlice";

const LinkViewBlockCard = ({ item }) => {
  const { darkMode } = useSelector((state) => state.theme);
  const ImageUrl = process.env.REACT_APP_API_URL;
  const dispatch = useDispatch();

  const [WinW, setWinW] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWinW(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const [state, setState] = useState(null);
  const [state, setState] = useState({ status: item?.status || false });
  const [URLvalue, setURLvalue] = useState(null);
  useEffect(() => {
    setState(item);
    setURLvalue(JSON.parse(item?.coloum_value)?.coloum_value);
  }, [item]);

  const changeCardStatus = async (e) => {
    const { checked } = e.target.value;
    setState({ ...state, status: checked });
    // e.prevent.default()
    const data = {
      status: checked,
      optionid: item?._id,
    };
    await dispatch(creatingChangeBLock(data)).then(() => {});

    await fetchingLinkList();
  };

  const fetchingLinkList = async () => {
    // const linkId = getLinktate?.getBioLink?.response?.[0]?._id;
    const linkId = localStorage.getItem("linkId");
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.userid;
    const usertoken = user.token;
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    await dispatch(gettingLinkList(linkListData));
    dispatch(resetLinkList());
  };

  return (
    <div
      className={`rounded-lg md:rounded-[10px] ${
        darkMode ? "" : "shadow-shadow_2 md:shadow-box_shadow_1"
      } bg-white dark:bg-dark-secondary p-4 md:p-[15px] flex items-center gap-[13px] md:gap-[15px]`}
    >
      <ThreeDot />
      {item?.linkIcon && (
        <div>
          <img
            className={`max-h-[41px] min-h-[41px] h-[41px] max-w-[41px] min-w-[41px] w-[41px] object-cover rounded-md `}
            src={` ${
              item?.linkIcon ? ImageUrl + "/profile/" + item?.linkIcon : ""
            }`}
            alt=""
          />
        </div>
      )}
      <div className="w-full flex justify-between">
        <div className=" ">
          <div className=" text-small2_b text-body_copy1_color dark:text-color_v1_dark capitalize">
            {WinW < 470
              ? item?.coloum_type?.length > 21
                ? item?.coloum_type?.slice(0, 21) + "..."
                : item?.coloum_type
              : WinW < 768
              ? item?.coloum_type?.length > 32
                ? item?.coloum_type?.slice(0, 32) + "..."
                : item?.coloum_type
              : WinW < 990
              ? item?.coloum_type?.length > 14
                ? item?.coloum_type?.slice(0, 14) + "..."
                : item?.coloum_type
              : WinW < 1400
              ? item?.coloum_type?.length > 27
                ? item?.coloum_type?.slice(0, 27) + "..."
                : item?.coloum_type
              : item?.coloum_type?.length > 41
              ? item?.coloum_type?.slice(0, 41) + "..."
              : item?.coloum_type}
          </div>

          <div className="text-small3 text-font_light_color dark:text-color_v1_dark">
            {WinW < 470
              ? URLvalue?.length > 27
                ? URLvalue?.slice(0, 27) + "..."
                : URLvalue
              : WinW < 768
              ? URLvalue?.length > 45
                ? URLvalue?.slice(0, 45) + "..."
                : URLvalue
              : WinW < 990
              ? URLvalue?.length > 18
                ? URLvalue?.slice(0, 18) + "..."
                : URLvalue
              : WinW < 1400
              ? URLvalue?.length > 39
                ? URLvalue?.slice(0, 39) + "..."
                : URLvalue
              : URLvalue?.length > 57
              ? URLvalue?.slice(0, 57) + "..."
              : URLvalue}
          </div>
        </div>
        <div className="flex gap-2 md:gap-[15px] items-center">
          <Link to={`/dashboard/component/editLink/${item?._id}`}>
            {darkMode ? <EditIconDark /> : <EditIcon />}
          </Link>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={state?.status}
              onChange={(e) => changeCardStatus(e)}
              className="sr-only peer"
            />
            <div className="w-[29px] h-[15px] bg-gray-200 rounded-full peer  peer-checked:after:translate-x-[13.5px] peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[11px] after:w-[11px] after:transition-all peer-checked:bg-green-600"></div>
          </label>
        </div>
      </div>
    </div>
  );
};

const AddLinkForm = ({ handleDelete, item }) => {
  const dispatch = useDispatch();
  const [subLoading, setSubLoading] = useState(false);

  const submitHandler = async (data) => {
    setSubLoading(true);
    data.columnName = "link";
    if (!/^(http|https):\/\//i.test(data.coloumnValue)) {
      data.coloumnValue = "https://" + data.coloumnValue;
    }

    await dispatch(creatingLinkBlock(data)).then(() => {
      handleDelete(item);
      fetchingLinksList();
    });
    setSubLoading(false);
  };

  const fetchingLinksList = () => {
    //  _______data needed for linklist api
    const user = JSON.parse(localStorage.getItem("user"));

    const userId = user.userid;
    const usertoken = user.token;
    const linkId = localStorage.getItem("linkId");
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };

    dispatch(gettingLinkList(linkListData));
  };

  const deleteHandler = () => {
    handleDelete(item);
  };

  return (
    <LinkForm
      formType={"add"}
      deleteHandler={deleteHandler}
      submitHandlerParent={submitHandler}
      isLoading={subLoading}
    />
  );
};

const Links = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate, currentLang } = useLocales();
  const { themeDirection } = useSettings();
  const { setActiveMainPageNav } = useStateContext();
  const [forms, setForms] = useState([{ id: 1 }]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setActiveMainPageNav(true);
    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // handling heading api reponses messages
  const { isLinkError, isLinkSuccess, isLinkLoading } = useSelector(
    (state) => state?.linkBlock
  );
  const { status, message } = useSelector(
    (state) => state?.linkBlock?.linkBlock
  );

  const handleDelete = (item) => {
    if (forms.length > 1) {
      setForms((prev) => {
        const prevForms = [...prev];
        return prevForms.filter((arr) => arr.id !== item.id);
      });
    }
  };

  useEffect(() => {
    if (status === "success" && isLinkSuccess) {
      toast.success(message);
      navigate("/dashboard");
    } else {
      if (isLinkError) {
        toast.error(message);
      }
    }
    dispatch(resetUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLinkError, isLinkSuccess, dispatch, isLinkLoading]);

  const [blocks, setBlocks] = useState([]);

  const filteredLinkData = blocks?.filter(
    (item) => item?.language === currentLang?.value
  );

  const mylinkstate = useSelector((state) => state?.linkList || []);
  const myData = mylinkstate?.getLinkList?.response;

  useEffect(() => {
    setBlocks(myData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mylinkstate]);

  return (
    <>
      <div className=" md:px-0 px-6  mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark"> {translate("links")} </p>
          </div>
        </Link>
        <button
          onClick={() => {
            setForms((prev) => [
              ...prev,
              {
                id: prev[prev.length - 1].id + 1, // Assuming you want to assign a unique identifier to the new item
                // Add other properties of the new item here
              },
            ]);
          }}
          className="rounded-full cursor-pointer flex gap-2 lg:gap-[12.5px] p-2 lg:pt-[9px] px-4 lg:px-[26px] text-white bg-main_color lg:text-small2_b text-small3_b"
        >
          <div className="text-gray-50 -pt-1 lg:text-xl text-lg">
            <MdAdd />
          </div>
          {translate("custom_link")}
        </button>
      </div>

      {forms?.map((item, i) => {
        return (
          <AddLinkForm key={item.id} item={item} handleDelete={handleDelete} />
        );
      })}
      <div className="pt-[30px] mb-[37px] md:px-0 px-6 flex flex-col gap-4">
        {filteredLinkData?.map((item, i) => {
          switch (item.coloum_name) {
            case "link":
              return <LinkViewBlockCard key={item?._id} item={item} />;
            default:
              return null;
          }
        })}
      </div>
    </>
  );
};

export default Links;
